import styled from 'styled-components'
import { themeGet } from 'styled-system'
import {
  CalendarInput,
  FormInputNumber,
  WarningIcon,
} from 'secondstep-components'

export const AddGoalsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const AddGoalsCopy = styled.div`
  margin-bottom: 0.1875rem;
  font-size: 1rem;
  line-height: 1.25rem;
  color: ${themeGet('colors.darkGray')};
  font-family: ${themeGet('font.molde.regular')};
`

export const InputsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 1rem;
  justify-content: space-between;

  ${themeGet('breakpoints.mobile')} {
    flex-direction: column;
    gap: 1rem;
  }
`

export const DateWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`

export const NumberWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  input {
    background: white;
  }
`

export const DateTitle = styled.div`
  font-size: 0.75rem;
  line-height: 1rem;
  color: ${themeGet('colors.darkGray')};
  font-family: ${themeGet('font.molde.medium')};
  margin-bottom: 0.25rem;
`

export const NumberTitle = styled.div`
  font-size: 0.75rem;
  line-height: 1rem;
  color: ${themeGet('colors.darkGray')};
  font-family: ${themeGet('font.molde.medium')};
  margin-bottom: 0.25rem;
`

export const OptionalGoalsSection = styled.section``

export const StyledWarningIcon = styled(WarningIcon)`
  height: 9px;
  width: 9px;
  margin-right: 0.25rem;

  circle:first-child {
    fill: ${themeGet('colors.errorRed')};
  }
`

export const Error = styled.div`
  display: flex;
  align-items: baseline;
  text-align: left;
  font-size: 0.75rem;
  margin-top: 0.375rem;
  color: ${themeGet('colors.errorRed')};
`

export const NumberError = styled(Error)`
  margin-top: -0.5rem;
`

export const ErrorText = styled.span`
  line-height: 0.9375rem;
  font-family: ${themeGet('font.molde.medium')};
`

export const StyledFormInputNumber = styled(FormInputNumber)`
  input {
    height: 46px;
    border-color: ${themeGet('colors.blueGrayMedium')};
  }
`

export const StyledCalendarInput = styled(CalendarInput)`
  height: 42px;
  border-color: ${themeGet('colors.blueGrayMedium')};
`
